import {
  API_GET_MY_JOB,
  API_GET_JOB_FOR_TECH,
  API_GET_MY_JOB_PAG,
  API_GET_MY_JOB_PAG2,
  API_GET_MY_JOB_TECH_PAG2,
  API_GET_JOB_FOR_TECH_UUID,
  API_LINKS_FOR_JOB,
  API_LINKS_FOR_JOB_TECH,
  API_LINKS_FOR_JOB_TECH2,
  API_DELETE_JOB,
  API_GET_TECHS,
  API_ASSIGN,
  API_NEXT_STEP,
  API_FALLBACK,
  CHANGE_PRINTREADY_PARAMETERS,
  API_LINKS_3D_PRECISE
} from '../config';
import { switch_api } from './switch_api';

export function getClientJobs() {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_GET_MY_JOB), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_GET_MY_JOB }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((json) => dispatch({type: 'GET_JOBS', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function getJobUuid(uuid) {
  let token =  localStorage.getItem('token')
  return  fetch(switch_api(API_GET_JOB_FOR_TECH_UUID(uuid)), {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Token '+token,
      'Content-Type': 'application/json; charset=utf-8'
    },
    credentials: 'include'
  })
  .then((response) => {
    if (!response.ok) {
      console.error("Failed loading { API_GET_JOB_FOR_TECH_UUID }: " + response.statusText);
    }
    return response;
  })
  .then((response) => response.json())
  // .then((json) => dispatch({type: 'GET_JOB', json}))
  .catch((e) => {
    // dispatch(userLoggedInFailure('' + e))
  })
}

export function getTechJobs() {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_GET_MY_JOB_PAG), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_GET_JOB_FOR_TECH }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((jobs) => {
      localStorage.setItem('techJobs', JSON.stringify(jobs));
      return jobs;
    })
    .then((json) => dispatch({type: 'GET_JOBS', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function getTechJobs2(date_from, date_to) {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_GET_MY_JOB_PAG2(date_from, date_to)), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_GET_JOB_FOR_TECH }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((jobs) => {
      localStorage.setItem('techJobs', JSON.stringify(jobs));
      return jobs;
    })
    .then((json) => dispatch({type: 'GET_JOBS', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function getTechJobs3(date_from, date_to) {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_GET_MY_JOB_TECH_PAG2(date_from, date_to)), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_GET_JOB_FOR_TECH }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((jobs) => {
      localStorage.setItem('techJobs', JSON.stringify(jobs));
      return jobs;
    })
    .then((json) => dispatch({type: 'GET_JOBS', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function getTechs(uuid) {
  let token =  localStorage.getItem('token')
  // return (dispatch) => {

  // }

  return fetch(switch_api(API_GET_TECHS(uuid)), {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Token '+token,
      'Content-Type': 'application/json; charset=utf-8'
    },
    credentials: 'include'
  })
  .then((response) => {
    if (!response.ok) {
      console.error("Failed loading { API_GET_TECHS }: " + response.statusText);
    }
    return response;
  })
  .then((response) => response.json())
  // .then((techs) => {
  //   // localStorage.setItem('techJobs', JSON.stringify(jobs));
  //   return techs;
  // })
  // .then((json) => dispatch({type: 'GET_TECHS', json}))
  .catch((e) => {
    // dispatch(userLoggedInFailure('' + e))
    return e;
  })
}

export async function getTreatmentPlansData(uuid) {
  let token =  localStorage.getItem('services_token');

  const result = await fetch(switch_api(API_LINKS_3D_PRECISE(uuid)), {
    method: "POST",
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Authorization': 'Bearer '+token,
      'Content-Type': 'application/json; charset=utf-8',
    }
  })
    .then((result) => {
      if (result.ok) {
        return result.json()
      }
      else {
        alert(`Error: ${ result.statusText }`)
      }
    })
  return result;
}

export function assign(job_uuid, assignee_uuid, group_id) {
  let token =  localStorage.getItem('token')
  // return (dispatch) => {

  // }

  return fetch(switch_api(API_ASSIGN(job_uuid)), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Token '+token,
      'Content-Type': 'application/json; charset=utf-8'
    },
    credentials: 'include',
    body: JSON.stringify({ assignee_uuid, group_id })
  })
  .then((response) => {
    if (!response.ok) {
      console.error("Failed loading { API_ASSIGN }: " + response.statusText);
    }
    return response;
  })
  .then((response) => response.json())
  // .then((techs) => {
  //   // localStorage.setItem('techJobs', JSON.stringify(jobs));
  //   return techs;
  // })
  // .then((json) => dispatch({type: 'GET_TECHS', json}))
  .catch((e) => {
    // dispatch(userLoggedInFailure('' + e))
    return e;
  })
}

export function getLinks(uuid) {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_LINKS_FOR_JOB(uuid)), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_LINKS_FOR_JOB }: " + response.statusText);
        dispatch({type: 'NO_LINKS'})
      }
      return response;
    })
    .then((response) => response.json())
    .then((json) => dispatch({type: 'GET_LINKS', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function getLinksTech(uuid) {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_LINKS_FOR_JOB_TECH(uuid)), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_LINKS_FOR_JOB_TECH }: " + response.statusText);
        dispatch({type: 'NO_LINKS'})
      }
      return response;
    })
    .then((response) => response.json())
    .then((json) => dispatch({type: 'GET_LINKS', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function getLinksTech2(uuid) {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_LINKS_FOR_JOB_TECH2(uuid)), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_LINKS_FOR_JOB_TECH2 }: " + response.statusText);
        dispatch({type: 'NO_LINKS'})
      }
      return response;
    })
    .then((response) => response.json())
    .then((json) => dispatch({type: 'GET_LINKS', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function deleteJob(uuid) {
  let token = localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_DELETE_JOB(uuid)), {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed deleting { API_DELETE_JOB }: " + response.statusText);
        dispatch(getTechJobs());
      }
      return response;
    })
    .then(() => dispatch(getTechJobs()))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function nextStep(uuid) {
  let token = localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_NEXT_STEP(uuid)), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed next step { API_NEXT_STEP }: " + response.statusText);
        dispatch(getTechJobs());
      }
      return response;
    })
    .then(() => dispatch(getTechJobs()))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function fallback(uuid) {
  let token = localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_FALLBACK(uuid)), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed next step { API_FALLBACK }: " + response.statusText);
        dispatch(getTechJobs());
      }
      return response;
    })
    .then(() => dispatch(getTechJobs()))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function changePrintReadyParams(job_id, gum_cutting_plane_distance) {
  let token = localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(CHANGE_PRINTREADY_PARAMETERS), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify({ job_id, gum_cutting_plane_distance })
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed next step { CHANGE_PRINTREADY_PARAMETERS }: " + response.statusText);
        dispatch(getTechJobs());
      }
      return response;
    })
    .then(() => dispatch(getTechJobs()))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/jobs.js